import {CalendarEvent} from '../components/SaveToCalendar/types';
import addMinutesToDate from './addMinutesToDate';

function getEndTime(calendarEvent: CalendarEvent) {
	return (
		calendarEvent.endDate ??
		addMinutesToDate(calendarEvent.startDate, calendarEvent.durationInMinutes)
	);
}

export default getEndTime;
